
// src/contexts/AdminContext.js
import axios from "axios";
import React, { createContext, useContext, useEffect, useState } from "react";

const AdminContext = createContext();


const API_BASE = "https://api.propertygalleria.in/master/api";
const API_BASEE = "http://localhost:4001";


export const AdminProvider = ({ children }) => {
  const [zones, setZones] = useState([]);
  const [projects, setProjects] = useState([]);
  const [projectHeads, setProjectHeads] = useState([]);
  const [associates, setAssociates] = useState([]);
  const [investor, setInvestor] = useState([]);
  const [propertyOwners, setPropertyOwners] = useState([]);

  const [InvestorLead, setInvestorLead] = useState([]);

  /* ========== FETCH PROJECTS ========== */
  const fetchProjects = async () => {
    try {
      const res = await axios.get(`${API_BASE}/get/projects`);
      setProjects(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to load projects");
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  useEffect(() => {
    fetchZones();
  }, []);

  /* ========== ADD PROJECT ========== */
  const addProject = async (data) => {
    const fd = new FormData();
    fd.append("zone_code", data.zoneId);
    fd.append("project_name", data.name);
    fd.append("project_area", data.area);
    fd.append("no_of_plots", data.plots);
    fd.append("plot_size", data.size);
    fd.append("facing", data.facing);

    if (data.layoutImage) {
      fd.append("layout", data.layoutImage);
    }

    (data.documents || []).forEach((doc) => {
      fd.append("documents", doc);
    });

    await axios.post(`${API_BASE}/api/projects`, fd);

    // 🔥 wrap fetchProjects separately
    try {
      await fetchProjects();
    } catch (e) {
      console.warn("Project created, but refresh failed");
    }
  };


  /* ========== UPDATE PROJECT ========== */
  const updateProject = async (id, data) => {
    try {
      const fd = new FormData();
      fd.append("zone_code", data.zoneId);
      fd.append("project_name", data.name);
      fd.append("project_area", data.area);
      fd.append("no_of_plots", data.plots);
      fd.append("plot_size", data.size);
      fd.append("facing", data.facing);
      fd.append("documents", JSON.stringify(data.existingDocuments || []));

      if (data.layoutImage) {
        fd.append("layout", data.layoutImage);
      }

      data.documents.forEach((doc) => {
        fd.append("documents", doc);
      });

      await axios.put(`${API_BASE}/api/projects/${id}`, fd);
      fetchProjects();
    } catch (err) {
      console.error(err);
      alert("Failed to update project");
    }
  };

  /* ========== DELETE PROJECT ========== */
  const deleteProject = async (id) => {
    try {
      await axios.delete(`${API_BASE}/api/projects/${id}`);
      fetchProjects();
    } catch (err) {
      console.error(err);
      alert("Failed to delete project");
    }
  };


  const fetchZones = async () => {
    try {

      const res = await axios.get(`${API_BASE}/api/zones`);
      setZones(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to fetch zones");
    }
  };


  useEffect(() => {
    fetchProjectHeads();
  }, []);



  /* ========== FETCH PROJECT HEADS ========== */
  const fetchProjectHeads = async () => {
    try {
      const res = await axios.get(`${API_BASE}/projectHead`);
      setProjectHeads(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to fetch project heads");
    }
  };

  /* ========== ADD PROJECT HEAD ========== */
  // const addProjectHead = async (data) => {
  //   try {
  //     const project = projects.find((p) => p.id === Number(data.projectId));
  //     const projectName = project ? project.project_name : data.projectId;

  //     const res = await axios.post(`${API_BASE}/api/project-heads`, {
  //       ph_name: data.name,
  //       mobile: data.mobile,
  //       email: data.email,
  //       project_name: projectName,
  //     });

  //    setProjectHeads([
  //   ...projectHeads,
  //   {
  //     ph_code: res.data.ph_code,
  //     ph_name: data.name,
  //     mobile: data.mobile,
  //     email: data.email,
  //     project_name: projectName,
  //   },
  // ]);

  //   } catch (err) {
  //     console.error(err);
  //     alert("Failed to add project head");
  //   }
  // };
  /* ========== ADD PROJECT HEAD ========== */
  const addProjectHead1 = async (data) => {
    try {
      const project = projects.find(
        (p) => p.id === Number(data.projectId)
      );

      const payload = {
        full_name: data.name,
        mobile_number: data.mobile,
        email: data.email,
        project_id: data.projectId,
        project_name: project?.project_name,
      };

      const res = await axios.post(
        `${API_BASE}/api/adminProjectHead`,
        payload
      );

      setProjectHeads([
        ...projectHeads,
        {
          user_id: res.data.project_head_id,
          ph_code: res.data.project_head_code, // PH001
          ph_name: data.name,
          mobile: data.mobile,
          email: data.email,
          project_id: data.projectId,
          project_name: project?.project_name,
        },
      ]);

    } catch (err) {
      console.error(err);
      alert("Failed to add project head");
    }
  };

  const addProjectHead = async (data) => {
    try {
      const res = await axios.post(
        `${API_BASE}/api/adminProjectHead`,
        data, // FormData
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to add project head");
    }
  };




  /* ========== UPDATE PROJECT HEAD ========== */
  // const updateProjectHead = async (ph_code, data) => {
  //   try {
  //     // Map ID to name
  //     const project = projects.find((p) => p.id === data.projectId);
  //     const projectName = project ? project.project_name : data.projectId;

  //     await axios.put(`${API_BASE}/api/project-heads/${ph_code}`, {
  //       ph_name: data.name,
  //       mobile: data.mobile,
  //       email: data.email,
  //       project_name: projectName, // send actual name
  //     });

  //    setProjectHeads([
  //   ...projectHeads,
  //   {
  //     ph_code: data.ph_code,
  //     ph_name: data.name,
  //     mobile: data.mobile,
  //     email: data.email,
  //     project_name: projectName,
  //   },
  // ]);

  //   } catch (err) {
  //     console.error(err);
  //     alert("Failed to update project head");
  //   }
  // };

  /* ========== UPDATE PROJECT HEAD ========== */
  const updateProjectHead1 = async (user_id, data) => {
    try {
      const project = projects.find(
        (p) => p.id === Number(data.projectId)
      );

      const payload = {
        project_id: data.projectId,
        project_name: project?.project_name,
      };

      await axios.put(
        `${API_BASE}/api/project-heads/${user_id}`,
        payload
      );

      setProjectHeads(
        projectHeads.map((head) =>
          head.user_id === user_id
            ? {
              ...head,
              ph_name: data.name,
              mobile: data.mobile,
              email: data.email,
              project_id: data.projectId,
              project_name: project?.project_name,
            }
            : head
        )
      );

    } catch (err) {
      console.error(err);
      alert("Failed to update project head");
    }
  };

  const updateProjectHead = async (user_id, data) => {
    try {
      await axios.put(
        `${API_BASE}/put/project-heads/${user_id}`,
        data
      );

      setProjectHeads((prev) =>
        prev.map((head) =>
          head.user_id === user_id
            ? {
              ...head,
              full_name: data.full_name,
              email: data.email,
              mobile_number: data.mobile_number,
              project_id: data.project_id,
              project_name: data.project_name,
            }
            : head
        )
      );

    } catch (err) {
      console.error(err);
      alert("Failed to update project head");
    }
  };


  /* ========== DELETE PROJECT HEAD ========== */
  // const deleteProjectHead = async (ph_code) => {
  //   try {
  //     await axios.delete(`${API_BASE}/api/project-heads/${ph_code}`);
  //     setProjectHeads(projectHeads.filter((head) => head.ph_code !== ph_code));
  //   } catch (err) {
  //     console.error(err);
  //     alert("Failed to delete project head");
  //   }
  // };


  /* ========== DELETE PROJECT HEAD ========== */
  const deleteProjectHead = async (user_id) => {
    try {
      await axios.delete(
        `${API_BASE}/api/project-heads/${user_id}`
      );

      setProjectHeads(
        projectHeads.filter((head) => head.user_id !== user_id)
      );

    } catch (err) {
      console.error(err);
      alert("Failed to delete project head");
    }
  };


// investor

  const fetchInvestor = async () => {
    try {
      const res = await axios.get(`${API_BASE}/users/investor`);
      setInvestor(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to fetch associates");
    }
  };
  useEffect(() => {
    fetchInvestor();
  }, []);

  /* ========== FETCH ASSOCIATES ========== */
  const fetchAssociates = async () => {
    try {
      const res = await axios.get(`${API_BASE}/users/agentss`);
      setAssociates(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to fetch associates");
    }
  };


  /* ========== ADD ASSOCIATE ========== */
  const addAssociate = async (data) => {
    try {
      //  const res = await axios.post(`${API_BASE}/api/adminAgent`, {
      const res = await axios.post(`${API_BASE}/api/register`, {
        // name: data.name,
        // email: data.email,
        // mobile: data.mobile,
        // project_name: data.project_name,
        // aadhar_no: data.aadharKyc,
        role: "agent",
        full_name: data.full_name,
        email: data.email,
        mobile_number: data.mobile_number,
        aadhaar_number: data.aadhaar_number || undefined,
        reports_to_head_id: data.reports_to_head_id,
        aadhaar_verified: "1",
        experience_years: data.experience_years,         // or from input if you add it
        project_name: data.project_name || "",
        is_admin_approve: 1    ,      // 👈 always 1
        state:data.state,
        city:data.city,
        profession:data.profession,
        designation:data.designation,
          referred_by: data.referred_by,
      });

      setAssociates([...associates, { ...data, id: res.data.id }]);
            fetchAssociates();
    } catch (err) {
      console.error(err);
      alert("Failed to add associate");
    }
  };


  /* ========== UPDATE ASSOCIATE ========== */
  // const updateAssociate_old = async (associate_code, data) => {
  //   try {
  //     await axios.put(`${API_BASE}/api/associates/${associate_code}`, {
  //       name: data.name,
  //       email: data.email,
  //       mobile: data.mobile,
  //       project_name: data.project_name,
  //       aadhar_no: data.aadharKyc,
  //     });
  //     fetchAssociates();
  //     // Update state
  //     setAssociates(
  //       associates.map((a) =>
  //         a.associate_code === associate_code ? { ...a, ...data } : a
  //       )
  //     );
  //   } catch (err) {
  //     console.error(err);
  //     alert("Failed to update associate");
  //   }
  // };
  /* ========== UPDATE ASSOCIATE ========== */
  const updateAssociate = async (userId, data) => {
    try {
      await axios.put(`${API_BASE}/api/adminAgent/${userId}`, {
        full_name: data.full_name,
        email: data.email,
        mobile_number: data.mobile_number,
        aadhaar_number: data.aadhaar_number,
        experience_years: data.experience_years,
        project_name: data.project_name,
        reports_to_head_id: data.reports_to_head_id,
          referred_by: data.referred_by,
      });

      alert("Associate updated successfully");
      fetchAssociates();

    } catch (err) {
      console.error(err);
      alert("Failed to update associate");
    }
  };


  /* ========== DELETE ASSOCIATE ========== */
  const deleteAssociate = async (associate_code) => {
    try {
      await axios.delete(`${API_BASE}/deleteAssociates/${associate_code}`);
      setAssociates(associates.filter((a) => a.user_id !== associate_code));
    } catch (err) {
      console.error(err);
      alert("Failed to delete associate");
    }
  };

  /* ========== Fetch associates on load ========== */
  useEffect(() => {
    fetchAssociates();
  }, []);


  const addPropertyOwner = async (data) => {
    try {
      const res = await axios.post(`${API_BASE}/adminOwner`, data);
      fetchPropertyOwners()
      setPropertyOwners([...propertyOwners, { ...data, id: res.data.id }]);
    } catch (err) {
      console.error(err);
      alert("Failed to add property owner");
    }
  };


  const updatePropertyOwner = async (id, data) => {
    try {
      await axios.put(`${API_BASE}/adminOwner/${id}`, data);
      fetchPropertyOwners()
      // setPropertyOwners(
      //   propertyOwners.map(o =>
      //     o.id === id ? { ...o, ...data } : o
      //   )
      // );
      setPropertyOwners(
        propertyOwners.map(o =>
          o.user_id === id ? { ...o, ...data } : o
        )
      );

    } catch (err) {
      console.error(err);
      alert("Failed to update property owner");
    }
  };


  const fetchPropertyOwners = async () => {
    try {
      const res = await axios.get(`${API_BASE}/users/propertyOwners`);
      setPropertyOwners(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to fetch property owners");
    }
  };

  useEffect(() => {
    fetchPropertyOwners();
  }, []);


  const deletePropertyOwner = async (id) => {
    try {
      await axios.delete(`${API_BASE}/propertyOwners/${id}`);
      setPropertyOwners(propertyOwners.filter((a) => a.user_id !== id));
    } catch (err) {
      console.error(err);
      alert("Failed to delete associate");
    }
  };


  /* ========== FETCH ASSOCIATES ========== */
  const fetchInvestorLead = async () => {
    try {
      const res = await axios.get(`${API_BASE}/investorLeads`);
      setInvestorLead(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to fetch Investors");
    }
  };
  // console.log('this is InvestorLead',InvestorLead)

  useEffect(() => {
    fetchInvestorLead(InvestorLead);
  }, []);


  return (
    <AdminContext.Provider
      value={{
        zones, projects, addProject, updateProject, deleteProject, projectHeads,
        addProjectHead,
        updateProjectHead,
        deleteProjectHead, associates,
        addAssociate,
        updateAssociate,
        deleteAssociate, propertyOwners,
        addPropertyOwner,
        updatePropertyOwner,
        deletePropertyOwner,

        InvestorLead,
        fetchPropertyOwners,
        fetchAssociates,
        fetchInvestorLead,
        fetchInvestor, investor
      }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => useContext(AdminContext);
